export const IS_GEMPAGES_V6_VALUE="false"
export const IS_GEMPAGES_V7_VALUE="true"
export const IS_GEMPAGES_MIXED_VALUE="mixed"
